import { render } from "./expertsManager.vue?vue&type=template&id=73c1a5a8&scoped=true"
import script from "./expertsManager.vue?vue&type=script&lang=js"
export * from "./expertsManager.vue?vue&type=script&lang=js"

import "./expertsManager.vue?vue&type=style&index=0&id=73c1a5a8&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c1a5a8"]])

export default __exports__